var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data column_center"},[_c('img',{attrs:{"src":require("../assets/no_data_2.png"),"alt":""}}),_c('div',{staticClass:"d_txt"},[_vm._v("暂无相关数据")])])
}]

export { render, staticRenderFns }